import React from 'react';
import { Eyebrow, H2, Section } from '../ui/Section';
import { CtaButton } from '../ui/CtaButton';
import { stages } from '../../data/content';
export function RoadmapSection() {
  return <Section tone="dark" narrow data-id="element-286" data-mp="2fj4zfv102uvd">
      <Eyebrow tone="dark" data-id="element-287" data-mp="2fjeptjpyj41l">The transformation</Eyebrow>
      <H2 className="mt-3" data-id="element-288" data-mp="2ajsddchydrtu">
        Build Your Implant Planning Roadmap in <span className="text-accent" data-id="element-289" data-mp="2almyorx4zlyg">7 Organized Stages.</span>
      </H2>
      <p className="mt-5 text-lg leading-relaxed text-white/80" data-id="element-290" data-mp="2pfi1bg6p8f17">
        Use a repeatable framework to document and review the key considerations involved in implant treatment planning.
      </p>

      <ol className="relative mt-10" data-id="element-291" data-mp="2y7ti0ac0go3z">
        {stages.map((s, i) => <li key={s.verb} className="relative flex gap-4 pb-8 last:pb-0" data-id="element-292" data-mp="2u6zvnle7vhd7" data-mpi={i}>
            {i < stages.length - 1 && <span className="absolute left-[23px] top-12 h-[calc(100%-48px)] w-0.5 bg-line" aria-hidden="true" data-id="element-293" data-mp="386hms7ezj6pq" />}
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-accent font-display text-lg font-black text-ink" data-id="element-294" data-mp="33991hxyjimk9">
              {String(i + 1).padStart(2, '0')}
            </span>
            <div className="pt-1" data-id="element-295" data-mp="29t8lt21jei2">
              <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight" data-id="element-296" data-mp="2b499k06w64y">{s.verb}</h3>
              <p className="mt-1.5 text-base leading-relaxed text-white/80" data-id="element-297" data-mp="b9zk59e6i4el">{s.text}</p>
            </div>
          </li>)}
      </ol>

      <div className="mt-12 rounded-2xl bg-panel p-6 text-center ring-1 ring-line" data-id="element-298" data-mp="g812tt7p01pj">
        <p className="font-display text-xl font-extrabold uppercase leading-tight text-gold sm:text-2xl" data-id="element-299" data-mp="l7dmy676iuof">
          One system. Seven stages. A clearer way to organize your thinking.
        </p>
        <p className="mt-4 text-base text-white/80" data-id="element-300" data-mp="uygm32gjszl2">The purpose isn’t to replace your clinical expertise.</p>
        <p className="mt-1 text-base text-white/80" data-id="element-301" data-mp="z0boybe4nl0y">
          It’s to give your clinical knowledge a structured framework for educational case planning and review.
        </p>
      </div>

      <div className="mt-10" data-id="element-302" data-mp="3019ur7cp21mc">
        <CtaButton tone="dark" label="I want a clear implant planning roadmap" note="Immediate Digital Access · $27 USD" data-id="element-303" data-mp="302kv0x6xkr8p" />
      </div>
    </Section>;
}